import {
  Bird, Leaf, MapPin, MagnifyingGlass, PawPrint, Plant, Tree, Bug,
  FileText, Flower, FirstAidKit, Footprints, Cat, Fish, Butterfly, Mountains
} from "@phosphor-icons/react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CHART_COLORS = ["#55624F", "#C25A3C", "#D99559", "#6B8E23", "#8B4513", "#2E8B57", "#4682B4", "#7C8068"];

const templateIcons = {
  bird: Bird,
  mountains: Mountains,
  plant: Plant,
  paw: PawPrint,
  tree: Tree,
  bug: Bug,
  file: FileText,
  flower: Flower,
  fungi: FirstAidKit,
  snake: Footprints,
  cat: Cat,
  fish: Fish,
  butterfly: Butterfly
};

const categoryConfig = {
  bird: { color: "#C25A3C", icon: Bird, label: "Birds" },
  mammal: { color: "#55624F", icon: PawPrint, label: "Mammals" },
  reptile: { color: "#8B4513", icon: Footprints, label: "Reptiles" },
  amphibian: { color: "#2E8B57", icon: Fish, label: "Amphibians" },
  fish: { color: "#4682B4", icon: Fish, label: "Fish" },
  insect: { color: "#D99559", icon: Bug, label: "Insects" },
  spider: { color: "#7C8068", icon: Bug, label: "Spiders" },
  plant: { color: "#6B8E23", icon: Plant, label: "Plants" },
  flower: { color: "#DB7093", icon: Flower, label: "Flowers" },
  tree: { color: "#228B22", icon: Tree, label: "Trees" },
  mushroom: { color: "#8B4513", icon: FirstAidKit, label: "Mushrooms" },
  fungi: { color: "#8B4513", icon: FirstAidKit, label: "Fungi" },
  butterfly: { color: "#DA70D6", icon: Butterfly, label: "Butterflies" },
  wildlife: { color: "#55624F", icon: PawPrint, label: "Wildlife" },
  other: { color: "#7C8068", icon: Leaf, label: "Other" },
  unknown: { color: "#7C8068", icon: MagnifyingGlass, label: "Unknown" }
};

export { BACKEND_URL, API, CHART_COLORS, templateIcons, categoryConfig };
